import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faCheckCircle,
  faCircleNotch,
  faDownload,
  faFile,
  faEye,
  faExternalLinkSquareAlt,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faInfoCircle,
  faQuestionCircle,
  faSearch,
  faSmile,
  faSort,
  faTimes,
  faUserCircle,
  faArrowRight,
  faArrowLeft,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFileExcel,
  faFileImage,
  faLink,
  faClipboardList
} from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import { Footer } from 'src/components/Footer/Footer';
import { Header } from 'src/components/Header/Header';
import { AppConsumer, AppProvider, IAppState } from 'src/contexts/Context';
import { Offering } from 'src/pages/Offering/Offering';
import { Search } from 'src/pages/Search/Search';
import { initGA } from 'src/components/GoogleAnalytics/GoogleAnalytics';
import { IAuthenticationResult } from '../../authentication/Authentication';
import './App.css';
import { Report } from 'src/pages/Report/Report';

// Make fontawesome icons available to use in other components.
library.add(
  faInfoCircle,
  faSearch,
  faCheck,
  faSmile,
  faUserCircle,
  faQuestionCircle,
  faCheckCircle,
  faCircleNotch,
  faTimes,
  faSort,
  faFile,
  faDownload,
  faEye,
  faExternalLinkSquareAlt,
  faLink,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faArrowRight,
  faArrowLeft,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFileExcel,
  faFileImage,
  faClipboardList
);

interface IAppProps {
  state?: string;
  authenticationResult: IAuthenticationResult;
}

export class App extends React.Component<IAppProps, IAppState> {
  public componentDidMount() {
    const trackingCode = process.env.REACT_APP_GOOGLE_ANALYTICS_CODE;
    if (typeof trackingCode === 'string') {
      initGA(trackingCode);
    }
  }

  public render() {
    return (
      <AppProvider authenticationResult={this.props.authenticationResult}>
        <AppConsumer>
          {({ apiActions, actions }) => (
            <Flex direction={FlexDirection.column} style={{ minHeight: '100vh' }}>
              <Header />
              <Switch>
                <Route exact={true} path="/" component={Search} />
                {/* <Route exact={true} path="/" component={Search} /> */}
                <Route
                  exact={true}
                  path="/offering/:id"
                  render={props => (
                    <Offering
                      waitForSolutionsToBeLoaded={apiActions.waitForSolutionsLoaded}
                      setSelectedSolution={actions.setSelectedSolution}
                      parseSolutionImageHtml={apiActions.parseSolutionImageHtml}
                      incrementSolutionView={apiActions.incrementSolutionView}
                      getSolutionViews={apiActions.getSolutionViews}
                    />
                  )}
                />
                <Route
                  exact={true}
                  path="/report"
                  render={() => (
                    <Report
                      getViewCounts={apiActions.getMostViewedAndPopularSolutions}
                      waitForSolutionsLoaded={apiActions.waitForSolutionsLoaded}
                    />
                  )}
                />
              </Switch>
              <Footer />
            </Flex>
          )}
        </AppConsumer>
      </AppProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/App.tsx